/**
 * Legal Content Config - ALL products
 * Edit this ONE file to update all legal pages across all subdomains
 */

const COMMON = {
  parentCompany: "GetKhojo",
  parentDomain: "getkhojo.com",
  contactEmail: "support@getkhojo.com",
  privacyEmail: "privacy@getkhojo.com",
  legalEmail: "legal@getkhojo.com",
  address: "Vadodara, Gujarat, India",
  jurisdiction: "Gujarat, India",
  lastUpdated: "May 2026",
  disclaimer: "Automated configuration and compliance analysis tool — no active exploitation or unauthorized access"
};

const PRODUCTS = {
  aegis: {
    name: "AEGIS",
    fullName: "Aegis Security",
    tagline: "AI-powered cybersecurity",
    description: "AI-powered Website Security & Compliance Checker (BETA)",
    productNoun: "scanner",
    actionVerb: "scan",
    dataType: "scan results, target URLs",
    kycRequired: true,
    paymentSupported: true
  },
  debug: {
    name: "BUGSCOUT",
    fullName: "Khojo BugScout",
    tagline: "CHECK. FIX. SHIP.",
    description: "Automated Web Security Configuration Checker",
    productNoun: "bug tester",
    actionVerb: "test",
    dataType: "test results, target URLs",
    kycRequired: false,
    paymentSupported: false
  },
  sip: {
    name: "SIP TESTER",
    fullName: "SIP Tester",
    tagline: "TEST · ANALYZE · RESOLVE",
    description: "VoIP infrastructure testing platform",
    productNoun: "SIP tester",
    actionVerb: "test",
    dataType: "test results, server addresses",
    kycRequired: false,
    paymentSupported: false
  }
};

export const getLegalContent = () => {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const sub = hostname.split('.')[0];
  const product = sub === 'debug' ? PRODUCTS.debug : sub === 'sip' ? PRODUCTS.sip : PRODUCTS.aegis;
  return { ...COMMON, ...product };
};

export { COMMON, PRODUCTS };
